import { Component, input } from '@angular/core';

@Component({
  selector: 'app-badge-text',
  templateUrl: './badge-text.component.html',
  styleUrl: './badge-text.component.scss',
})
export class BadgeTextComponent {
  readonly color = input<'green' | 'blue' | 'pink'>('green');
  readonly deal = input<boolean>(false);
  readonly icon = input<string>();
  readonly text = input<string>();
}
